import {
    OfferSelectionResult,
    OfferSuggestionStreamEvent,
    streamOfferSuggestions,
} from '../../../common/api/clients/intelligence.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { useIntelligenceStream, UseIntelligenceStreamResult } from '../../create-enquiry/hooks/useIntelligenceStream';

export const useOfferSuggestionsStream = (
    orderId: string
): UseIntelligenceStreamResult<OfferSelectionResult, OfferSuggestionStreamEvent> => {
    return useIntelligenceStream<OfferSelectionResult, OfferSuggestionStreamEvent>(orderId, {
        queryKey: queries.intelligence.offerSuggestions(orderId).queryKey,
        streamFunction: streamOfferSuggestions,
        streamName: 'Offer suggestions',
    });
};
